import breakpointsFunc from '../breakpointsFunc';
const MuiStepper = {
  styleOverrides: {
    root: {
      maxWidth: '890px',
      margin: '0 auto',
      [breakpointsFunc.breakpoints.down('lg')]: {
        maxWidth: '720px'
      }
    }
  }
};
export default MuiStepper;